
import { translateActions } from './translate-slice';
import { genderTypes } from '../enums/genderTypes';
import { fetchJson } from '../utils/utils';

export const initTexts = () => {
    return async (dispatch, getState) => {
        try {
            const state = getState();
            const genderId = state.auth.userDetails?.genderId
            const lang = state.translate.lang

            let res = await fetchJson(window.config.translationFile.replace('lang', lang))

            let myTexts = null;
            if (Object.keys(res).some(key => Object.values(genderTypes).includes(key))) { // support jsones without genders
                const genderText = res[genderTypes[genderId]] || {};
                const allText = res["all"] || {};
                myTexts = { ...allText, ...genderText }
            }
            else
                myTexts = res?.all

            dispatch(translateActions.initText({ texts: myTexts }))
        }
        catch {

        }
    }
}

export const changeLang = (lang) => {
    return async (dispatch, getState) => {
        try {
            const state = getState();
            const { user } = state.auth;
            localStorage.setItem(`LANG-${user.exidentifier}`, lang);
            window.location.reload();
        }
        catch {
            console.log('error in change lang');
        }
    }
}